import { apiFetch, apiFetchV2 } from '@m/utils/http';

import type { IntegrationConfigResponse } from '../components/IntegrationTable/types';

export const IntegrationService = {
  getIntegrationOptions: ({ zoneId }: { zoneId: number | string }) =>
    apiFetch(`/admin/site/${zoneId}/external-zone-integration-types`),

  getSavedIntegrations: ({ zoneId }: { zoneId: number | string }) =>
    apiFetch(`/admin/site/${zoneId}/external-zone-integrations`),

  getSavedIntegrationConfigurations: ({ zoneId }: { zoneId: number | string }) =>
    apiFetchV2<IntegrationConfigResponse>(
      `/admin/site/${zoneId}/external-zone-integration-configurations`,
    ),

  saveIntegrations: ({
    zoneId,
    externalZones,
  }: {
    externalZones: { id: string; integration: string }[];
    zoneId: number | string;
  }) =>
    apiFetch(`/admin/site/${zoneId}/save-external-zone-integrations`, {
      method: 'POST',
      body: { externalZones },
    }),

  saveIntegrationConfigurations: ({
    zoneId,
    externalZones,
  }: {
    externalZones: {
      id: string;
      integration: string;
      integrationConfiguration?: {
        affiliateId: string;
        carParkId: string;
        configurationPageUrl: string;
        schemaIdentifier: string;
      };
    }[];
    zoneId: number | string;
  }) =>
    apiFetchV2<IntegrationConfigResponse>(
      `/admin/site/${zoneId}/save-external-zone-integration-configurations`,
      {
        method: 'POST',
        body: { externalZones },
      },
    ),
};
